import script from "./SearchScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchScreen.vue?vue&type=script&setup=true&lang=js"

import "./SearchScreen.vue?vue&type=style&index=0&id=0775e81c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0775e81c"]])

export default __exports__